import { render, staticRenderFns } from "./TheAddonsFields.vue?vue&type=template&id=831b2e2e&scoped=true&"
import script from "./TheAddonsFields.vue?vue&type=script&lang=ts&"
export * from "./TheAddonsFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831b2e2e",
  null
  
)

export default component.exports